<div class="rough-headline">
  <h1 class="rough-headline__headline" #headlineElement>{{ text }}</h1>
</div>
